/**
 * Custom hook untuk mengambil detail inventory category berdasarkan ID
 * 
 * API Endpoint: GET `/api/inventory-category/:id`
 * API Version: 4.0
 * 
 * @param {string} id - ID inventory category
 * @returns {object} - Return value berupa object dengan key `data`, `isLoading`, dan `error`.
 * @example
 * const { data, isLoading, error } = useShowInventoryCategory({ id: '1' });
 */


import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { InventoryCategoryResponseSchema } from "../response/ShowInventoryCategoryResponse";

interface ShowInventoryCategoryProps {
    id?: string;
}

const useShowInventoryCategory = ({ id }: ShowInventoryCategoryProps) => {
    return useQuery({
        queryKey: ['inventory-categories', id],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/v4/inventory-category/${id}`);

                // Validasi response
                const validationResult = InventoryCategoryResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid inventory category data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch inventory category`, error);
                throw error;
            }
        },
        enabled: !!id,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useShowInventoryCategory;
